import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExecutionModel } from '../../Models/execution-model';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/Services/user.service';
import { getBrand } from 'src/environments/brand';

export interface SuiteExecutionConfigData {
  suiteName: string;
  suiteId: string;
  existingConfig?: ExecutionConfig;
}

export interface ExecutionConfig {
  browser: string[];
  hub_ip: string;
  port: any;
  default_pause: string;
  send_mail: boolean;
  resolution: string;
  screenshot_required: boolean;
  default_hub: boolean;
  local_execution: boolean;
  execution_machine: string;
  xDimension?: number;
  yDimension?: number;
  isURLWithoutPort?: boolean;
  customIp?: string;
  is_implicit_default_pause?: boolean;
}

@Component({
  selector: 'app-suite-execution-config-dialog',
  templateUrl: './suite-execution-config-dialog.component.html',
  styleUrls: ['./suite-execution-config-dialog.component.scss']
})
export class SuiteExecutionConfigDialogComponent implements OnInit {
  brand = getBrand();
  executionModel: ExecutionConfig;
  browserList: string[] = ['Chrome', 'Firefox', 'Opera'];
  delayList = [
    { name: 'No delay', value: '0' },
    { name: '1', value: '1000' },
    { name: '2', value: '2000' },
    { name: '3', value: '3000' },
    { name: '5', value: '5000' },
    { name: '7', value: '7000' },
    { name: '10', value: '10000' }
  ];
  resolutionList: any[] = [];
  defaultResolution = 'default_resolution';
  xDimension: number = 1920;
  yDimension: number = 1200;
  customIp: string = '';
  isCustomIpSelected: boolean = false;
  showDropdown: boolean = false;
  listofUser: any[] = [];
  selectedOption: string = '';
  inputboxDisables: boolean = true;
  haveDeviceResolutions: boolean = true;

  deviceResolutions = [
    { name: 'Device BlackBerry Z30', value: 'Device:BlackBerry_Z30' },
    { name: 'Device Blackberry PlayBook', value: 'Device:Blackberry_PlayBook' },
    { name: 'Device Galaxy Z Fold 5', value: 'Device:Galaxy_Z_Fold_5' },
    { name: 'Device Galaxy Note 3', value: 'Device:Galaxy_Note_3' },
    { name: 'Device Galaxy Note II', value: 'Device:Galaxy_Note_II' },
    { name: 'Device Galaxy S III', value: 'Device:Galaxy_S_III' },
    { name: 'Device Galaxy S5', value: 'Device:Galaxy_S5' },
    { name: 'Device Galaxy S8', value: 'Device:Galaxy_S8' },
    { name: 'Device Galaxy S9+', value: 'Device:Galaxy_S9+' },
    { name: 'Device Samsung Galaxy S8+', value: 'Device:Samsung_Galaxy_S8+' },
    { name: 'Device Samsung Galaxy S20 Ultra', value: 'Device:Samsung_Galaxy_S20_Ultra' },
    { name: 'Device Samsung Galaxy A51/71', value: 'Device:Samsung_Galaxy_A51_A71' },
    { name: 'Device Galaxy Tab S4', value: 'Device:Galaxy_Tab_S4' },
    { name: 'Device Kindle Fire HDX', value: 'Device:Kindle_Fire_HDX' },
    { name: 'Device LG Optimus L70', value: 'Device:LG_Optimus_L70' },
    { name: 'Device Microsoft Lumia 550', value: 'Device:Microsoft_Lumia_550' },
    { name: 'Device Microsoft Lumia 950', value: 'Device:Microsoft_Lumia_950' },
    { name: 'Device Moto G Power', value: 'Device:Moto_G_Power' },
    { name: 'Device Moto G4', value: 'Device:Moto_G4' },
    { name: 'Device Nexus 10', value: 'Device:Nexus_10' },
    { name: 'Device Nexus 4', value: 'Device:Nexus_4' },
    { name: 'Device Nexus 5', value: 'Device:Nexus_5' },
    { name: 'Device Nexus 5X', value: 'Device:Nexus_5X' },
    { name: 'Device Nexus 6', value: 'Device:Nexus_6' },
    { name: 'Device Nexus 6P', value: 'Device:Nexus_6P' },
    { name: 'Device Nexus 7', value: 'Device:Nexus_7' },
    { name: 'Device Nokia Lumia 520', value: 'Device:Nokia_Lumia_520' },
    { name: 'Device Nokia N9', value: 'Device:Nokia_N9' },
    { name: 'Device Pixel 2', value: 'Device:Pixel_2' },
    { name: 'Device Pixel 2 XL', value: 'Device:Pixel_2_XL' },
    { name: 'Device Pixel 3', value: 'Device:Pixel_3' },
    { name: 'Device Pixel 3 XL', value: 'Device:Pixel_3_XL' },
    { name: 'Device Pixel 4', value: 'Device:Pixel_4' },
    { name: 'Device Pixel 7', value: 'Device:Pixel_7' },
    { name: 'Device JioPhone 2', value: 'Device:JioPhone_2' },
    { name: 'Device iPhone SE', value: 'Device:iPhone_SE' },
    { name: 'Device iPhone XR/11', value: 'Device:iPhone_XR_11' },
    { name: 'Device iPhone 12/13 Pro', value: 'Device:iPhone_12_13_Pro' },
    { name: 'Device iPhone 14 Pro Max', value: 'Device:iPhone_14_Pro_Max' },
    { name: 'Device iPhone 4', value: 'Device:iPhone_4' },
    { name: 'Device iPhone 5/SE', value: 'Device:iPhone_5_SE' },
    { name: 'Device iPhone 6/7/8', value: 'Device:iPhone_6_7_8' },
    { name: 'Device iPhone 6/7/8 Plus', value: 'Device:iPhone_6_7_8_Plus' },
    { name: 'Device iPhone X/XS', value: 'Device:iPhone_X_XS' }
  ];

  constructor(
    public dialogRef: MatDialogRef<SuiteExecutionConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuiteExecutionConfigData,
    private userService: UserService
  ) {
    this.updateResolutionList(true);
    this.initializeExecutionModel();
  }

  ngOnInit() {
    if (!this.executionModel.default_hub) {
      this.getExecutionUrls();
    }
  }

  initializeExecutionModel() {
    if (this.data.existingConfig) {
      this.executionModel = { ...this.data.existingConfig };
      this.xDimension = this.executionModel.xDimension || 1920;
      this.yDimension = this.executionModel.yDimension || 1200;
      this.customIp = this.executionModel.customIp || '';
      this.selectedOption = this.executionModel.execution_machine || '';
      this.isCustomIpSelected = !!this.customIp;
      this.inputboxDisables = this.executionModel.default_hub;
      this.executionModel.default_pause = String(this.executionModel.default_pause || '0');
      // Ensure port has a default value if not set
      if ((this.executionModel.port == undefined || this.executionModel.port == null) && !this.executionModel.isURLWithoutPort) {
        this.executionModel.port = environment.selenoidHubPort || 4445;
      }
    } else {
      this.executionModel = {
        browser: ['Chrome'],
        hub_ip: environment.selenoidHubIp,
        port: environment.selenoidHubPort || 4445,
        default_pause: '0',
        send_mail: false,
        resolution: this.defaultResolution,
        screenshot_required: false,
        default_hub: true,
        local_execution: false,
        execution_machine: 'Default Machine',
        is_implicit_default_pause: false
      };
    }
  }

  updateResolutionList(includeDeviceResolutions: boolean) {
    const baseResolutions = [
      { name: 'Default Resolution', value: 'default_resolution' },
      { name: '640x480', value: '640x480' },
      { name: '800x600', value: '800x600' },
      { name: '1024x768', value: '1024x768' },
      { name: '1280x720', value: '1280x720' },
      { name: '1280x800', value: '1280x800' },
      { name: '1366x768', value: '1366x768' },
      { name: '1440x900', value: '1440x900' },
      { name: '1600x900', value: '1600x900' },
      { name: '1680x1050', value: '1680x1050' },
      { name: '1920x1080', value: '1920x1080' },
      { name: '1920x1200', value: '1920x1200' }
    ];

    const customResolution = [
      { name: 'Custom Resolution', value: 'custom_resolution' }
    ];

    if (includeDeviceResolutions) {
      this.resolutionList = baseResolutions.concat(this.deviceResolutions).concat(customResolution);
      this.haveDeviceResolutions = true;
    } else {
      this.resolutionList = baseResolutions.concat(customResolution);
      this.haveDeviceResolutions = false;
    }
  }

  onBrowserChange(): void {
    if (this.executionModel.browser.length == 0 || (this.executionModel.browser.length == 1 && this.executionModel.browser[0] == 'Chrome')) {
      if (!this.haveDeviceResolutions) {
        this.updateResolutionList(true);
      }
    } else {
      if (this.haveDeviceResolutions) {
        if (this.executionModel.resolution.startsWith('Device:')) {
          this.executionModel.resolution = this.defaultResolution;
        }
        this.updateResolutionList(false);
      }
    }
  }

  onCheckboxChange() {
    if (this.executionModel.default_hub) {
      this.executionModel.hub_ip = environment.selenoidHubIp;
      this.executionModel.execution_machine = 'Default Machine';
      this.executionModel.port = environment.selenoidHubPort;
      this.selectedOption = '';
      this.inputboxDisables = true;
      this.executionModel.local_execution = false;
    } else {
      this.executionModel.default_hub = false;
      this.getExecutionUrls();
      this.inputboxDisables = false;
      if (this.executionModel.isURLWithoutPort) {
        this.executionModel.port = -1;
      } else {
        this.executionModel.port = '';
      }
    }
  }

  getExecutionUrls() {
    const projectId = localStorage.getItem('projectId');
    if (projectId) {
      this.userService.getLocalExecutionUrls(projectId, 'web').subscribe(
        (response: any) => {
          this.listofUser = response || [];
        }
      );
    }
  }

  selectOption(option: any) {
    this.inputboxDisables = true;
    this.selectedOption = option.username;
    this.executionModel.port = option.localExecutionModels[0].port;
    this.showDropdown = false;
    this.executionModel.hub_ip = option.localExecutionModels[0].url;
    this.executionModel.execution_machine = option.username + "'s Host";
    this.executionModel.local_execution = true;
    this.executionModel.default_hub = false;
    this.isCustomIpSelected = false;
    this.customIp = '';
  }

  selectOptionforCustom() {
    this.inputboxDisables = false;
    this.selectedOption = 'Custom IP';
    this.showDropdown = false;
    this.executionModel.local_execution = true;
    this.executionModel.default_hub = false;
    this.isCustomIpSelected = true;
  }

  toggleDropdown(state: boolean) {
    if (this.executionModel.default_hub) {
      this.inputboxDisables = true;
      this.showDropdown = false;
    } else {
      this.showDropdown = state;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdownElement = target.closest('.editable-dropdown');

    // If click is outside the dropdown, close it
    if (!dropdownElement && this.showDropdown) {
      this.showDropdown = false;
    }
  }

  isURLWithoutPORT() {
    this.executionModel.isURLWithoutPort = !this.executionModel.isURLWithoutPort;
    if (this.executionModel.isURLWithoutPort) {
      this.executionModel.port = -1;
    } else {
      // Restore default port when unchecking
      this.executionModel.port = environment.selenoidHubPort || 4445;
    }
  }

  save() {
    let finalPort = this.executionModel.port;

    if (this.executionModel.isURLWithoutPort) {
      finalPort = -1;
    } else if (this.executionModel.port == undefined || this.executionModel.port == null) {
      finalPort = '';
    }

    const config: ExecutionConfig = {
      ...this.executionModel,
      port: finalPort,
      xDimension: this.xDimension,
      yDimension: this.yDimension,
      customIp: this.isCustomIpSelected ? this.customIp : undefined,
      hub_ip: this.isCustomIpSelected && this.customIp ? this.customIp : this.executionModel.hub_ip
    };

    this.dialogRef.close(config);
  }

  onIsURLWithoutPortChange() {
    if (this.executionModel.isURLWithoutPort) {
      this.executionModel.port = -1;
    } else {
      this.executionModel.port = environment.selenoidHubPort || 4445;
    }
  }



  cancel() {
    this.dialogRef.close(null);
  }

  onDefaultPauseChange(value: any) {
    if (value === 0 || value === '0') {
      this.executionModel.is_implicit_default_pause = false;
    }
  }
}

